import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PAGE_SIZE = 25;

export function usePaged(rows, size = PAGE_SIZE) {
  const [page, setPage] = useState(1);
  const pages = Math.max(1, Math.ceil(rows.length / size));
  useEffect(() => {
    if (page > pages) {
      setPage(pages);
    }
  }, [page, pages]);
  const current = Math.min(page, pages);
  const go = (n) => {
    setPage(n);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return { page: current, pages, setPage: go, items: rows.slice((current - 1) * size, current * size), total: rows.length, size };
}

export const ListPager = ({ pager, label = "items", testId }) => {
  const { page, pages, setPage, total, size } = pager;
  if (total <= size) return null;
  const from = (page - 1) * size + 1;
  const to = Math.min(page * size, total);
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 text-sm text-slate-600" data-testid={testId}>
      <span data-testid={`${testId}-summary`}>Showing {from}–{to} of {total} {label}</span>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid={`${testId}-prev`}><ChevronLeft className="mr-1 h-4 w-4" /> Previous</Button>
        <span className="font-data text-xs" data-testid={`${testId}-page`}>Page {page} of {pages}</span>
        <Button variant="outline" size="sm" disabled={page >= pages} onClick={() => setPage(page + 1)} data-testid={`${testId}-next`}>Next <ChevronRight className="ml-1 h-4 w-4" /></Button>
      </div>
    </div>
  );
};
